<!-- <div>
    <b>
        <p>Übergeordnete Produkte</p> -->
<!-- </b> -->
<table>
    <tbody>
        <tr *ngFor="let relatedProduct of product.relatedProducts" class="not">
            <td class="wider">
                <p>
                    {{
                    productService.getRelatedProductNameFromId(
                    relatedProduct
                    )
                    }}
                </p>
            </td>
            <td>
                <red-cross-button-circle (press)="removeProductDependency(relatedProduct)">
                </red-cross-button-circle>
            </td>
        </tr>
    </tbody>
</table>
<!-- </div> -->